
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            利用規約
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            ボラタスサービスをご利用いただく前に、以下の利用規約をお読みください。
          </p>
          <div className="w-24 h-1 bg-teal-500 mx-auto"></div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            
            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第1条（適用）</h2>
              <p className="text-gray-700 leading-relaxed">
                本利用規約（以下「本規約」）は、財恩工房（以下「当事業者」）が提供するボラタスサービス（以下「本サービス」）の利用条件を定めるものです。
                利用者は、本サービスを利用することにより、本規約に同意したものとみなします。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第2条（利用登録）</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                本サービスの利用を希望する者は、本規約に同意の上、当事業者の定める方法によって利用登録を申請し、当事業者がこれを承認することによって、利用登録が完了するものとします。
              </p>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあります：
              </p>
              <ul className="space-y-2 text-gray-700 mt-4">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>利用登録の申請に際して虚偽の事項を届け出た場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>本規約に違反したことがある者からの申請である場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>その他、当事業者が利用登録を相当でないと判断した場合</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第3条（禁止事項）</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                利用者は、本サービスの利用にあたり、以下の行為をしてはなりません：
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>法令または公序良俗に違反する行為</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>犯罪行為に関連する行為</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>他の利用者、第三者または当事業者の権利を侵害する行為</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>虚偽の情報を登録する行為</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>本サービスの運営を妨害する行為</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第4条（本サービスの提供の停止等）</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、以下のいずれかの事由があると判断した場合、利用者に事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします：
              </p>
              <ul className="space-y-2 text-gray-700 mt-4">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>その他、当事業者が本サービスの提供が困難と判断した場合</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第5条（利用制限および登録抹消）</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、利用者が以下のいずれかに該当する場合には、事前の通知なく、利用者に対して、本サービスの全部もしくは一部の利用を制限し、または利用者としての登録を抹消することができるものとします：
              </p>
              <ul className="space-y-2 text-gray-700 mt-4">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>本規約のいずれかの条項に違反した場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>登録事項に虚偽の事実があることが判明した場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>その他、当事業者が本サービスの利用を適当でないと判断した場合</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第6条（免責事項）</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第7条（サービス内容の変更等）</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、利用者に通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによって利用者に生じた損害について一切の責任を負いません。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第8条（利用規約の変更）</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、必要と判断した場合には、利用者に通知することなくいつでも本規約を変更することができるものとします。
                なお、本規約の変更後、本サービスの利用を開始した場合には、当該利用者は変更後の規約に同意したものとみなします。
              </p>
            </div>

            <div className="bg-teal-50 border border-teal-200 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">第9条（準拠法・裁判管轄）</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                本規約の解釈にあたっては、日本法を準拠法とします。
              </p>
              <p className="text-gray-700 leading-relaxed">
                本サービスに関して紛争が生じた場合には、当事業者の本店所在地を管轄する裁判所を専属的合意管轄とします。
              </p>
              <p className="text-gray-600 mt-6 text-sm">
                制定日：2024年1月1日<br />
                最終更新日：2024年1月1日
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
